import Image from 'next/image'
import { useState } from 'react'

export default function ImageLoader({ alt, onError, ...props }) {
  const [src, setSrc] = useState(props.src)

  return (
    <Image {...props} src={src} alt={alt} onError={() => setSrc(onError)} />
  )
}
